import { Component, Inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatCard } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogUtilityService } from '@/app/services/utility/dialog-utility.service';
import { ActivatedRoute } from '@angular/router';
import { BriefSectionComponent } from '../brief-section/brief-section.component';
import { DomSanitizer } from '@angular/platform-browser';
import { DateFormatService } from '@/app/services/date-format.service';
import { PrintService } from '@/app/services/shared/print.service';
import { MatListModule } from '@angular/material/list';
import { AttachmentListComponent } from "../../../../../attachment-list/attachment-list.component";
@Component({
  selector: 'app-eoiindividual-response-preview',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatCard,
    MatDialogModule,
    BriefSectionComponent,
    MatListModule,
    AttachmentListComponent
],
  templateUrl: './eoiindividual-response-preview.component.html',
  styleUrl: './eoiindividual-response-preview.component.css',
})
export class EOIIndividualResponsePreviewComponent implements OnInit {
  eoiResponseData: any;
  isLoading = true;
  projectName: string;
  constructor(
    private projectsService: ProjectsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogUtilityService: DialogUtilityService,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private dateFormatService: DateFormatService,
    private printService:PrintService
  ) {}

  countryName: string;

  ngOnInit(): void {
    this.projectsService
      .getApplicantEoiView(this.data.projectId, this.data.eoiResponseId)
      .subscribe({
        next: (response) => {
          if (response?.data) {
            this.eoiResponseData = response?.data;
          }
          if (response?.data?.country_id) {
            this.projectsService
              .getCountry(response?.data?.country_id)
              .subscribe({
                next: (result) => {
                  if (result) {
                    this.countryName = result?.data?.name;
                  }
                },
                error: (err) => {
                  console.error('Error fetching data:', err);
                  this.isLoading = false;
                },
              });
          }
        },
        error: (err) => {
          console.error('Error fetching data:', err);
          this.isLoading = false;
        },
      });

    this.activatedRoute.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
    });
  }
  closeDialog() {
    this.dialogUtilityService.handleCloseDialog();
  }
  getSanitizedHtml(description: string) {
    if (!description) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }
  transformDate(date: Date | string): string {
    return this.dateFormatService.formatDate(date);
  }
  print() {
   this.printService.printContent('InitiateEoi','EOI-developer-company-response-view')
    this.closeDialog();
  }
}
